import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from 'cn';

const TABS = [
  { to: '/simulateur', label: 'Comparateur de régimes' },
  { to: '/simulateur/projection', label: 'Projection' },
  { to: '/simulateur/marche', label: 'Marché (DVF)' },
  { to: '/simulateur/secteurs', label: 'Secteurs' },
  { to: '/simulateur/achat-revente', label: 'Achat-revente' },
  { to: '/simulateur/hypotheses', label: 'Hypothèses' },
] as const;

export function SimulateurTabs() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  return (
    <nav aria-label="Simulateur" className="flex gap-2 border-b border-border">
      {TABS.map((tab) => {
        const active = pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'border-b-2 px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground',
              active ? 'border-primary text-foreground' : 'border-transparent',
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
